import { Expose, plainToInstance } from "class-transformer";
import camelcaseKeys from "camelcase-keys";

export class SmsAccountBalanceModel {
  @Expose()
  public expirationDate?: string;

  @Expose()
  public balance?: string;

  @Expose()
  public remainingDays?: string;

  public static toClass(data: object) {
    //@ts-ignore
    return plainToInstance(SmsAccountBalanceModel, camelcaseKeys(data, { deep: true }), { excludeExtraneousValues: true });
  }

  public static toArrayOfClass(data: object[]) {
    //@ts-ignore
    return plainToInstance(SmsAccountBalanceModel, camelcaseKeys(data, { deep: true }) as SmsAccountBalanceModel[], { excludeExtraneousValues: true });
  }
}
